import { useLocalSearchParams, useRouter } from "expo-router";
import { useCallback } from "react";
import { StyleSheet } from "react-native";

import { Block, Image, Touchable, spacing } from "@stepapp/ui";

export default function ImagePreviewScreen() {
  const { back, replace } = useRouter();
  const { uri } = useLocalSearchParams<{ uri: string }>();

  const closeImage = useCallback(() => {
    try {
      back();
    } catch (_) {
      replace("/");
    }
  }, [back, replace]);

  return (
    <Touchable activeOpacity={1} onPress={closeImage}>
      <Block alignCenter justifyCenter>
        <Image contentFit="contain" source={{ uri }} style={styles.image} />
      </Block>
    </Touchable>
  );
}

const styles = StyleSheet.create({
  image: {
    height: spacing.deviceHeight - spacing.headerHeight * 3,
    width: "100%",
  },
});
